import { adminApiFetch } from './apiService';

export const settingsService = {
  // 獲取設定
  get: async () => {
    const response = await adminApiFetch('settings', { method: 'GET' });
    return response.json();
  },

  // 更新設定
  update: async (formData) => {
    const response = await adminApiFetch('settings', {
      method: 'PATCH',
      body: formData,
      headers: {} // 讓 browser 自動設定 multipart/form-data
    });
    return response.json();
  }
};

export default settingsService;
